import { Tabs, Form } from "antd";
import PropTypes from "prop-types";
import { AddUser } from '../../style';
import { BasicFormWrapper } from '../../../styled';
import { DetailsOtherInfoUser } from '../GlobalComponents/UserCardCmnts'

const LeadTabPage = ({ displayData }) => {
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    return (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className="add-product-content">
                                <Tabs defaultActiveKey="1">
                                    <TabPane tab="Sponsor Info" key="1">
                                        <Form.Item label="Sponsor Type" name="type" className="custom-form-item">
                                            <span className="">{displayData?.account_type_name}</span>
                                        </Form.Item>
                                        <Form.Item label="Website" name="website" className="custom-form-item">
                                            <span className="">{displayData?.website}</span>
                                        </Form.Item>
                                        <Form.Item label="Industry" name="industry" className="custom-form-item">
                                            <span className="">{displayData?.industry_name}</span>
                                        </Form.Item>
                                        <Form.Item label="Ownership" name="ownership" className="custom-form-item">
                                            <span className="">{displayData?.ownership_name}</span>
                                        </Form.Item>
                                        <Form.Item label="No of Employees" name="noofemployees" className="custom-form-item">
                                            <span className="">{displayData?.nom_of_employees}</span>
                                        </Form.Item>
                                        <Form.Item label="Annual Revenue (USD)" name="annualrevenue" className="custom-form-item">
                                            <span className="">{displayData?.annual_revenue}</span>
                                        </Form.Item>
                                        <Form.Item label="Rating" name="rating" className="custom-form-item">
                                            <span className="">{displayData?.rating}</span>
                                        </Form.Item>
                                        {displayData?.account_type_name === "Customer" && <Form.Item label="Customer Status" name="customerStatus" className="custom-form-item">
                                            <span className="">{displayData?.customer_status}</span>
                                        </Form.Item>}
                                        <Form.Item label="Description" name="description" className="custom-form-item">
                                            <span className="">{displayData?.description}</span>
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Address Info" key="3">
                                        <Form.Item label="Country" name="country" id="country" className="custom-form-item">
                                            {displayData?.country}
                                        </Form.Item>
                                        <Form.Item label="State" className="custom-form-item">
                                            {displayData?.state}
                                        </Form.Item>
                                        <Form.Item label="City" className="custom-form-item">
                                            {displayData?.city}
                                        </Form.Item>
                                        <Form.Item label="Street name and No" name="street" className="custom-form-item">
                                            {displayData?.street}
                                        </Form.Item>
                                        <Form.Item label="Zip Code" name="postcode" className="custom-form-item">
                                            {(displayData?.postcode === "0" || displayData.postcode === 0) ? "" : (displayData?.postcode)}
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Other Info" key="4">
                                        <Form.Item label="Created By" className="custom-form-item" >
                                            {displayData?.created_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.created_by,
                                                    recordbyFName: displayData?.createdByFirstName,
                                                    recordbyLName: displayData?.createdByLastName,
                                                    date: displayData?.created_at
                                                }} /> : <></>}
                                        </Form.Item>
                                        <Form.Item label="Modified By" className="custom-form-item">
                                            {displayData?.modified_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.modified_by,
                                                    recordbyFName: displayData?.modifiedByFirstName,
                                                    recordbyLName: displayData?.modifiedByLastName,
                                                    date: displayData?.modified_at
                                                }} /> : <></>}
                                        </Form.Item>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </div>
        </AddUser >
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
}
export default LeadTabPage;
